<div class="wrap">
    <app-header></app-header>
    <div class="main-holder">
        <app-nav></app-nav>
        <div class="main">
            <div class="main-content">
                <div class="bread">
                    <ol>
                        <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg"></a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><a (click)="returnToList()" style="cursor: pointer;">Transactions</a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><span>Transaction Details</span></li>
                    </ol>
                </div>

                <div *ngIf="notFound" class="no-records-msg">
                    <h6 class="ponds-contents-med-bold">Transaction not found.</h6>
                </div>

                <div class="row" *ngIf="!notFound && detailViewed['status']">
                    <div class="col-md-8">
                        <div class="panel">
                            <div class="panel-head">
                                <h3>Booking Details</h3>
                                <span class="stat stat-canceled" *ngIf="detailViewed['status'] === 'pending'">Pending</span>
                                <span class="stat stat-ongoing" *ngIf="detailViewed['status'] === 'accepted'">Accepted</span>
                                <span class="stat stat-ongoing" *ngIf="detailViewed['status'] === 'ongoing_pickup'">Ongoing - Pickup</span>
                                <span class="stat stat-ongoing" *ngIf="detailViewed['status'] === 'ongoing_destination'">Ongoing - Destination</span>
                                <span class="stat stat-completed" *ngIf="detailViewed['status'] === 'completed'">Completed</span>
                                <span class="stat stat-canceled" *ngIf="detailViewed['status'] === 'canceled'">Cancelled</span>
                            </div>
                            <div class="panel-info">
                                <div class="panel-grp">
                                    <div class="mb-3 row">
                                        <label class="col-sm-3 col-form-label">Service</label>
                                        <div class="col-sm-9">
                                            <span class="stat stat-verified" *ngIf="transTabs['express']">Express</span>
                                            <span class="stat stat-verified" *ngIf="transTabs['okride']">OK! Ride</span>
                                            <span class="stat stat-verified" *ngIf="transTabs['mototaxi']">OK! MotoTaxi</span>
                                            <span class="stat stat-verified" *ngIf="transTabs['oktaxi']">OK! Taxi</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="panel-grp" *ngIf="transTabs['oktaxi']">
                                    <div class="mb-3 row">
                                        <label class="col-sm-3 col-form-label">Fleet Operator</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control" disabled [value]="getFleetOperatorName()">
                                        </div>
                                    </div>
                                </div>
                                <div class="panel-grp">
                                    <div class="mb-3 row">
                                        <label class="col-sm-3 col-form-label">Booking ID</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control" disabled [value]="getDetailTransactionId()">
                                        </div>
                                    </div>
                                </div>
                                <div class="panel-grp">
                                    <div class="mb-3 row">
                                        <label class="col-sm-3 col-form-label">Transaction ID</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control" disabled [value]="transId">
                                        </div>
                                    </div>
                                </div>
                                <div class="panel-grp">
                                    <div class="mb-3 row">
                                        <label class="col-sm-3 col-form-label">Booking Date</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control" disabled [value]="detailViewed['dateCreated'] | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD'">
                                        </div>
                                    </div>
                                </div>
                                <div class="panel-grp">
                                    <div class="mb-3 row">
                                        <label class="col-sm-3 col-form-label">Booking Time</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control" disabled [value]="detailViewed['dateCreated'] | amFromUtc | amLocal | amDateFormat: 'h:mm:ss A'">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="booking-holder">
                            <google-map height="250px" width="370px" [center]="center" [zoom]="zoom" (mapClick)="moveMap($event)"
                                (mapMousemove)="move($event)">
                                <map-polyline [path]="polyLinePath" [options]="polyLineOptions" />
                            </google-map>
                            <div class="booking-rider-details">
                                <div class="pfp">
                                    <img [src]="getPartnerPhoto()" alt="Partner">
                                </div>
                                <div class="rider-info" *ngIf="detailViewed['partner'] !== null">
                                    {{ detailViewed['partner']['firstName'] }} {{ detailViewed['partner']['middleName'] }}
                                    {{ detailViewed['partner']['lastName'] }}<br>
                                    <small *ngIf="transTabs['oktaxi']">{{ detailViewed['partner']['fleetRegistry']?.['vehicleModel'] || detailViewed['fleetVehicle']?.['vehicleModel'] || detailViewed['partner']['vehicleType'] }} &middot; {{ detailViewed['partner']['fleetRegistry']?.['plateNumber'] || detailViewed['fleetVehicle']?.['plateNumber'] || detailViewed['partner']['licensePlate'] }}</small>
                                    <small *ngIf="!transTabs['oktaxi']">{{ detailViewed['vehicleCategory'] }} - {{ detailViewed['vehicleId'] }}</small>
                                </div>
                                <div class="rider-info" *ngIf="detailViewed['partner'] === null">
                                    ---
                                </div>
                                <div class="rider-rating" *ngIf="detailViewed['partner'] !== null">
                                    <img src="../../../../assets/okito/images/star.svg">
                                    <h4 *ngIf="detailViewed['partnerRating'] === null">0.00</h4>
                                    <h4 *ngIf="detailViewed['partnerRating'] !== null">{{ detailViewed['partnerRating']['rate'] | number: '1.2-2' }}</h4>
                                </div>
                            </div>
                            <div class="booking-rider-details" *ngIf="transTabs['oktaxi'] && detailViewed['user']">
                                <div class="pfp">
                                    <img [src]="getPassengerPhoto()" alt="Passenger">
                                </div>
                                <div class="rider-info">
                                    {{ detailViewed['user']['name'] }}<br>
                                    <small>{{ detailViewed['user']['mobile'] }}</small>
                                </div>
                            </div>
                            <div class="booking-address">
                                <div class="booking-address-details">
                                    <img src="../../../../assets/okito/images/pickup.svg">
                                    <div class="sender-details">
                                        <label>Pick-up Location</label>
                                        <h4>{{ detailViewed['startFormattedAddress'] }}</h4>
                                        <div class="sender">
                                            <span>{{ detailViewed['senderName'] }}</span>
                                            <span>{{ detailViewed['senderMobile'] }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="booking-address-details">
                                    <img src="../../../../assets/okito/images/dropoff.svg">
                                    <div class="sender-details">
                                        <h4>{{ detailViewed['endFormattedAddress'] }}</h4>
                                        <div class="sender">
                                            <span>{{ detailViewed['receipientName'] }}</span>
                                            <span>{{ detailViewed['receipientMobile'] }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="booking-note">
                                <label>Note to rider</label>
                                <p>{{ detailViewed['notes'] }}</p>
                            </div>
                            <div class="booking-distance">
                                <div class="fees-grp">
                                    <div class="distance-label">
                                        <img src="../../../../assets/okito/images/dropoff.svg">
                                        <label>Distance</label>
                                    </div>
                                    <span>{{ transTabs['express'] ? detailViewed['totalDistance'] : detailViewed['kmDistance'] }} km</span>
                                </div>
                            </div>
                            <div class="pwdsc">
                                <div class="pwdsc-id">
                                    <img src="../../../../assets/okito/images/pwdsc.png">
                                    <div class="pwdsc-info">
                                        <label>Discount</label>
                                        <h4>PWD/SC/Student Card</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="booking-fees">
                                <div class="fees-grp">
                                    <label>Delivery Fee</label>
                                    <span>{{ detailViewed['farePrice'] | currency:'PHP' }}</span>
                                </div>
                                <div class="fees-grp">
                                    <label>Discount</label>
                                    <span class="discount">-{{ detailViewed['discountPrice'] | currency:'PHP' }}</span>
                                </div>
                                <div class="total-fees">
                                    <label>Total Delivery Fee</label>
                                    <div class="total">
                                        <img src="../../../../assets/okito/images/cash.svg">
                                        <span>{{ detailViewed['totalPrice'] | currency:'PHP' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
